import React from 'react';
import styles from '@shared/styles/components/ScrollArea.module.css';

interface ScrollAreaProps {
    children: React.ReactNode;
    className?: string;
}

const ScrollArea: React.FC<ScrollAreaProps> = ({ children, className }) => (
    <div className={[styles.scrollArea, 'DSScrollArea', className].filter(Boolean).join(' ')}>
        {children}
    </div>
);

export default ScrollArea;
